import { MutationTree } from 'vuex';
import { ContentMutations, ContentState } from './types';
import { ContentPage } from '@mentessa/types';

export const mutations: MutationTree<ContentState> = {
  [ContentMutations.SetContent](state: ContentState, page: ContentPage) {
    state.content = page;
  },
};
